<div
  class="d-flex justify-content-center loader flex-column align-items-center"
  *ngIf="loading"
>
  <div>
    <mat-spinner color="accent"></mat-spinner>
  </div>
</div>

<div class="main-wrapper py-4 px-3" *ngIf="!loading && category">
  <!-- Back Button & Breadcrumbs -->
  <div class="d-flex align-items-center mb-3">
    <button mat-icon-button routerLink="/categories" class="mr-2">
      <mat-icon>arrow_back</mat-icon>
    </button>
    <span class="text-muted text-sm">Categories / {{category.name}}</span>
  </div>

  <!-- Category Hero Card (Mock 3 layout) -->
  <div class="row m-0 mb-4">
    <div class="col-12 p-0">
      <div class="category-hero-card" [ngStyle]="{'background-image': 'url(' + category.logo.source + ')'}">
        <div class="category-hero-overlay p-5 d-flex flex-column justify-content-center">
          <h1 class="mat-display-2 font-weight-bold text-white mb-2">{{category.name}}</h1>
          <p class="text-white-80 mb-4 max-w-600">{{category.description}}</p>
          
          <div class="d-flex align-items-center flex-wrap gap-2 text-white">
            <span class="pill-tag text-white bg-primary border-0 font-weight-bold mr-2">
              <fa-icon [icon]="faBuilding" class="mr-1"></fa-icon> 
              {{category.businessess?.length || 0}} Businesses
            </span>
            <span class="pill-tag text-white bg-secondary border-0 font-weight-bold" *ngIf="ads?.length > 0">
              <fa-icon [icon]="faImage" class="mr-1"></fa-icon> 
              {{ads.length}} Featured Offers
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Filters Row (From Mock 3) -->
  <!-- <div class="row m-0 align-items-center mb-4 pb-2 border-bottom flex-wrap gap-2">
    <div class="d-flex gap-2 align-items-center flex-wrap">
      <button mat-stroked-button class="rounded-pill filter-pill active">
        <mat-icon class="mr-1">tune</mat-icon> Filter
      </button>
      <button mat-stroked-button class="rounded-pill filter-pill">
        Distance <mat-icon class="ml-1 text-sm">expand_more</mat-icon>
      </button>
      <button mat-stroked-button class="rounded-pill filter-pill">
        Open Now
      </button>
      <button mat-stroked-button class="rounded-pill filter-pill">
        Highest Rated
      </button>
    </div>
    <div class="spacer"></div>
    <span class="text-muted font-weight-bold">{{category.businessess?.length || 0}} Results found</span>
  </div> -->

  <!-- Content Tabs -->
  <div class="row m-0">
    <div class="col-12 p-0">
      <ng-container *ngIf="category.businessess.length < 1; else showBusinesses">
        <div class="modern-card p-5 text-center d-flex flex-column align-items-center justify-content-center">
          <h2 class="mb-3 font-weight-bold">Be the first to load your business in this category</h2>
          <button mat-flat-button color="accent" (click)="goTo('login')" class="rounded-pill px-4 py-2">
            Add My Business
          </button>
        </div>
      </ng-container>

      <ng-template #showBusinesses>
        <mat-tab-group class="modern-tabs">
          <!-- Businesses Tab -->
          <mat-tab label="Businesses">
            <div class="row m-0 pt-4">
              <!-- Grid Layout for Mobile Cards on Web -->
              <div class="col-md-4 mb-4 d-flex" *ngFor="let b of category.businessess">
                <div class="modern-card flex-column d-flex overflow-hidden w-100 hover-shadow link" (click)="viewBusiness(b)">
                  
                  <!-- Cover Image & Badge overlay -->
                  <div class="business-card-cover position-relative" [style.background-image]="'url(' + (b.Logo?.source || 'assets/about.jpg') + ')'">
                    <span class="featured-badge-overlay" *ngIf="b.TradingHours">FEATURED</span>
                  </div>

                  <!-- Profile Avatar Overlap -->
                  <div class="business-avatar-circle-overlap bg-primary text-white font-weight-bold d-flex align-items-center justify-content-center">
                    <img *ngIf="b.Logo?.source" [src]="b.Logo.source" alt="Logo" class="img-fluid rounded-circle" />
                    <span *ngIf="!b.Logo?.source">{{b.Name.substring(0, 2).toUpperCase()}}</span>
                  </div>

                  <div class="business-details-panel p-4 pt-5 flex-1 d-flex flex-column justify-content-between">
                    <div>
                      <!-- Header Title & Share -->
                      <div class="d-flex justify-content-between align-items-start mb-2">
                        <div>
                          <h3 class="font-weight-bold mb-1 text-dark text-lg">{{ b.Name }}</h3>
                          <p class="text-muted mb-0 text-xs"><mat-icon class="text-sm mr-1">place</mat-icon>{{ b.Address }}</p>
                        </div>
                        
                        <!-- Share Dropdown -->
                        <button mat-icon-button (click)="$event.stopPropagation()" [matMenuTriggerFor]="shareMenu" class="text-muted">
                          <fa-icon [icon]="faShareNodes"></fa-icon>
                        </button>
                        <mat-menu #shareMenu="matMenu">
                          <button mat-menu-item (click)="copyLink(b)">
                            <span>Copy Link</span>
                          </button>
                          <button mat-menu-item (click)="shareViaWhatsApp(b)">
                            <span>Share via WhatsApp</span>
                          </button>
                        </mat-menu>
                      </div>

                      <!-- Mock Ratings (Matching Mock 3 design) -->
                      <div class="d-flex align-items-center mb-3 text-xs">
                        <!-- <fa-icon [icon]="faStar" class="text-warning mr-1"></fa-icon>
                        <fa-icon [icon]="faStar" class="text-warning mr-1"></fa-icon>
                        <fa-icon [icon]="faStar" class="text-warning mr-1"></fa-icon>
                        <fa-icon [icon]="faStar" class="text-warning mr-1"></fa-icon>
                        <fa-icon [icon]="faStar" class="text-warning mr-1"></fa-icon> -->
                        <!-- <span class="font-weight-bold text-dark mr-1">4.9</span>
                        <span class="text-muted">(132 Reviews)</span>
                        <span class="text-muted ml-2">• 3.2 km away</span> -->
                      </div>

                      <!-- Trading Hours / Status badge -->
                      <div class="w-100 mb-3" *ngIf="b.TradingHours && b.TradingHours.length > 0">
                        <ng-container *ngFor="let day of b.TradingHours">
                          <div *ngIf="day.startTime && day.open && day.day === today" class="d-flex align-items-center text-xs">
                            <span class="status-indicator-dot mr-2" [ngClass]="compareTime(currentTime, day.endTime, day.startTime) === 'Open' ? 'bg-success' : 'bg-danger'"></span>
                            <span class="font-weight-bold mr-2 text-dark" [ngClass]="compareTime(currentTime, day.endTime, day.startTime) === 'Open' ? 'text-success' : 'text-danger'">
                              {{compareTime(currentTime, day.endTime, day.startTime) === 'Open' ? 'Open Now' : 'Closed'}}
                            </span>
                            <span class="text-muted">{{ day.startTime }} - {{ day.endTime }}</span>
                          </div>
                        </ng-container>
                      </div>

                      <!-- Web Stats Row (From Mock 3) -->
                      <!-- <div class="d-flex align-items-center justify-content-between p-2 border-top border-bottom text-muted text-xs mb-4">
                        <span class="d-flex align-items-center"><mat-icon class="text-sm mr-1">visibility</mat-icon> Views</span>
                        <span class="d-flex align-items-center"><mat-icon class="text-sm mr-1">group</mat-icon> Followers</span>
                        <span class="d-flex align-items-center"><mat-icon class="text-sm mr-1">insights</mat-icon> Leads</span>
                      </div> -->
                    </div>

                    <!-- Action buttons -->
                    <div class="business-action-buttons">
                      <button mat-flat-button color="primary" class="rounded-pill text-white py-1 bg-primary text-xs" (click)="viewBusiness(b); $event.stopPropagation()">
                        View Profile
                      </button>
                      <a [href]="'tel:' + b.Mobile" mat-stroked-button class="rounded-pill text-muted px-2 py-1 text-xs" (click)="$event.stopPropagation()">
                        Call
                      </a>
                      <a [href]="'https://www.google.com/maps/search/?api=1&query=' + b.Address" target="_blank" mat-stroked-button class="rounded-pill text-muted px-2 py-1 text-xs" (click)="$event.stopPropagation()">
                        Directions
                      </a>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </mat-tab>

          <!-- Ads Tab -->
          <mat-tab label="Offers & Ads">
            <div class="row m-0 pt-4">
              <div class="col-md-4 mb-4" *ngFor="let ad of ads; let i = index">
                <div class="modern-card overflow-hidden h-100 d-flex flex-column justify-content-between link" (click)="viewBusinessFromAd(ad.business.id)">
                  <app-ad [title]="ad.title" [body]="ad.body" [image1]="ad.image1"></app-ad>
                  <div class="p-3 bg-light d-flex justify-content-between align-items-center mt-auto">
                    <div>
                      <h4 class="font-weight-bold text-dark m-0 text-sm">{{ ad.business.get("Name") }}</h4>
                      <p class="text-muted m-0 text-xs text-truncate" style="max-width: 200px;">{{ ad.body }}</p>
                    </div>
                    <fa-icon [icon]="faCaretRight" class="text-primary"></fa-icon>
                  </div>
                </div>
              </div>
              <div class="col-12 text-center py-5" *ngIf="!ads || ads.length < 1">
                <h3 class="text-muted">No featured offers in this category yet.</h3>
              </div>
            </div>
          </mat-tab>

          <!-- Map Tab -->
          <mat-tab label="Location Map">
            <div class="pt-4 text-center">
              <div class="modern-card p-5 max-w-600 mx-auto">
                <mat-icon class="text-primary display-3 mb-3">map</mat-icon>
                <h3 class="font-weight-bold text-dark mb-3">View Interactive Directory Map</h3>
                <p class="text-muted mb-4">Log in or register for an account to browse service providers on an active map of your area.</p>
                <button mat-flat-button color="primary" routerLink="/auth" class="rounded-pill px-4 py-2 text-white bg-primary">
                  Login / Register
                </button>
              </div>
            </div>
          </mat-tab>
        </mat-tab-group>
      </ng-template>
    </div>
  </div>
</div>
